import { useState, useEffect } from 'react';
import { useGeocoder } from '../services/GeocoderGoogleMaps';
import { useSelector } from 'react-redux';
import { getCurrentUserLocationUnitsStr } from '../util/location';
import { excludeTypes } from '../util/googleMaps';
import { checkUserPredictionData, setUserPredictionData } from '../util/localStorage';
import { isLocalhost } from '../util/urlHelpers';


export const useCurrentUserGeoData = ({ allowed } = { allowed: true }) => {
    const geocoder = useGeocoder();

    const currentUser = useSelector(s => s.user.currentUser);

    const currentUseId = currentUser?.id?.uuid;

    const [loading, setLoading] = useState(false);
    const [geoData, setGeoData] = useState(null);

    const getGeoData = async () => {
        try {
            setLoading(true);

            const locationUnitsStr = getCurrentUserLocationUnitsStr(currentUser);

            const geoData = await geocoder.getPlaceDetailsFromString({
                locationUnitsStr,
                excludeTypes,
            });

            setGeoData(geoData);

            /**
              * prediction data has to be already set to local storage
              * after successful getPlacePredictions call
              */
            const userPredictionData = checkUserPredictionData(locationUnitsStr);

            if (userPredictionData && userPredictionData.data) {
                /**
                 * Re-set the local storage values with an extra params;
                 * Here we want the current location to be stored in
                 * the storage permanently, so the timestamp is set to Infinity
                 */
                /**
                 * local storage value is stringified, pure Infinity is converted to null;
                 * in order to avoid it, the Infinity is converted to a string 'Infinity'
                 */
                setUserPredictionData(locationUnitsStr, userPredictionData.data, { timestamp: 'Infinity' });
            }
        }
        catch (e) {
            if (isLocalhost()) {
                console.log('useCurrentUserGeoData.error:' + e.message);
            }
            return setGeoData(null)
        }
        finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (!allowed) return;
        if (!currentUseId) return;
        getGeoData();
    }, [allowed, currentUseId]);


    return { loading, geoData }
};
